/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { guidFor } from '@ember/object/internals';
import Component from '@glimmer/component';
import { Queue } from 'ember-file-upload';

interface CioFileInputButtonArgs {
  queue: Queue;
  disabled?: boolean;
  multiple?: boolean;
  accept?: string;
  buttonClasses?: string;
  onClick?: (evt: MouseEvent) => unknown;
}

export default class CioFileInputButton extends Component<CioFileInputButtonArgs> {
  readonly guid = guidFor(this);

  get accept() {
    return this.args.accept ?? '*';
  }

  get onClick() {
    return this.args.onClick ?? (() => {});
  }
}
